<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Our Portfolio</h2>
        </div>
    </div>
</div>

<section class="blog-area ptb-100">
    <div class="container">
        <div class="row mb-5 pb-4">
            <div class="col-lg-12 col-sm-12 text-center">
                <div class="icon mb-4">
                    <img src="assets/img/favicon.png" class="fav-size" alt="image">
                </div>
                <h2 class="mb-4">
                    <strong>Our expertise has benefited numerous leading businesses like yours</strong>
                </h2>
            </div>
        </div>
        <div class="row" *ngIf="portFolioList?.length > 0">
            <div class="col-lg-4 col-md-6" *ngFor="let portfolio of portFolioList; let p = index;">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a [href]="portfolio?.link" target="_blank">
                            <img src="assets/img/blog-image/{{portfolio?.image}}" alt="image" class="img-thumbnail"></a>
                    </div>
                    <div class="post-content">
                        <h3 class="mb-0"><a [href]="portfolio?.link" target="_blank">{{portfolio?.name}}</a></h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="free-trial-area ptb-100 bg-f4f5fe">
    <div class="container">
        <div class="free-trial-content">
            <h2>We always try to be the best support to you as possible</h2>
            <p>Qualify your leads & recognize the value of word your customer will love you</p>
            <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot"></i> Contact Us<span></span></a>
        </div>
    </div>
    <div class="shape10"><img src="assets/img/shape/shape10.png" alt="image"></div>
    <div class="shape11"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape12"><img src="assets/img/shape/shape11.png" alt="image"></div>
    <div class="shape13"><img src="assets/img/shape/shape12.png" alt="image"></div>
</section>